import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Roles } from '../../constants/enum';

@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss'],
  standalone: false,
})

/**
 * PAges-404 component
 */
export class Page404Component implements OnInit {
  currentUser: any;
  Roles = Roles;
  currentRole: any;
  constructor(private router: Router) {
    const currentUserString = localStorage.getItem('currentUser');
    if (currentUserString) {
      // Parse the data to a JavaScript object
      let currentUserData = JSON.parse(currentUserString);
      this.currentRole = currentUserData.currentUserRoleDetails.role;
    }
  }

  ngOnInit(): void {}
  backToDashboard() {
    if (this.currentRole == Roles.ADMIN || this.currentRole == Roles.DASHBOARDADMIN) {
      this.router.navigate(['/admindashboard']);
    } else if (this.currentRole == Roles.EVADMIN) {
      this.router.navigate(['/evReadings']);
    } else if (this.currentRole == Roles.SUPERADMIN) {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/consumerdashboard']);
    }
  }
}
